import {Injectable} from '@angular/core';
import {Ratio} from '../../model/ratio';

@Injectable({
  providedIn: 'root'
})
export class NumberParseService {


  // from https://stackoverflow.com/questions/29255843/is-there-a-way-to-reverse-the-formatting-by-intl-numberformat-in-javascript
  static parseLocaleNumber(stringNumber, ratio?: Ratio) {
    if (ratio == Ratio.PERCENTAGE) {
      return this.parseLocalPercentage(stringNumber);
    } else if (ratio == Ratio.PER_THOUSAND) {
      return this.parseLocalPerThousand(stringNumber);
    }
    if (typeof stringNumber === 'undefined' || stringNumber === '' || !/^[\d,.]*$/.test(stringNumber)) {
      return NaN;
    }

    const thousandSeparator = Intl.NumberFormat('de-DE').format(11111).replace(/\p{Number}/gu, '');
    const decimalSeparator = Intl.NumberFormat('de-DE').format(1.1).replace(/\p{Number}/gu, '');

    return parseFloat(stringNumber
      .replace(new RegExp('\\' + thousandSeparator, 'g'), '')
      .replace(new RegExp('\\' + decimalSeparator), '.')
    );
  }

  private static parseLocalPercentage(stringNumber) {
    if (stringNumber?.slice(-1) === '%') {
      stringNumber = stringNumber.slice(0, -1);
    }
    return this.parseLocaleNumber(stringNumber) / 100;
  }

  private static parseLocalPerThousand(stringNumber) {
    if (stringNumber?.slice(-1) === '‰') {
      stringNumber = stringNumber.slice(0, -1);
    }
    return this.parseLocaleNumber(stringNumber) / 1000;
  }

  static convertToPercentageDisplay(number, decimalPlaces, maxSize?: number, round: boolean = false) {
    number = number * 100;
    let cutOffNumber = this.calcCutOffNumber(decimalPlaces, number, round);
    if (maxSize && (cutOffNumber >= maxSize)) {
      cutOffNumber = maxSize;
    }
    return new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    }).format(cutOffNumber) + '%';
  }

  private static convertToPerThousand(number, decimalPlaces, maxSize?: number, round: boolean = false) {
    number = number * 1000;
    let cutOffNumber = this.calcCutOffNumber(decimalPlaces, number, round);
    if (maxSize && (cutOffNumber >= maxSize)) {
      cutOffNumber = maxSize;
    }
    return new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    }).format(cutOffNumber) + '‰';
  }

  private static convertToNumber(number, decimalPlaces, maxSize?: number, round: boolean = false) {
    let cutOffNumber = this.calcCutOffNumber(decimalPlaces, number, round);
    if (maxSize && cutOffNumber >= maxSize) {
      cutOffNumber = maxSize;
    }
    return new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    }).format(cutOffNumber);
  }

  public static calcCutOffNumber(decimalPlaces, number, round: boolean) {
    const factor = Math.pow(10, decimalPlaces);
    number = number * factor + 1 / (factor * 10);
    if (round) {
      number = Math.round(number);
    } else {
      number = Math.floor(number);
    }
    return number / factor;
  }

  convertToLocalNumber(number, decimalPlaces, maxSize?: number, ratio?: Ratio, round = false) {

    if (typeof number === 'undefined' || number === '') {
      return;
    }
    if (ratio == Ratio.PERCENTAGE) {
      return NumberParseService.convertToPercentageDisplay(number, decimalPlaces, maxSize, round);
    } else if (ratio == Ratio.PER_THOUSAND) {
      return NumberParseService.convertToPerThousand(number, decimalPlaces, maxSize, round);
    }
    return NumberParseService.convertToNumber(number, decimalPlaces, maxSize, round);
  }


}
